export const CLASE_SEMAFORO = {
	PENDIENTE: 'status-yellow',
	LIBERADA: 'status-green',
	RECHAZADA: 'status-red',
	CANCELADA: 'status-grey',
};

export const COLOR_ESTADO = {
	PENDIENTE: 'rgb(222, 207, 76)',
	LIBERADA: '#28D094',
	RECHAZADA: '#FF4961',
	CANCELADA: '#6B6F82',
};

export const etiquetaEstado = (intl, estado) => {
	switch (estado) {
		case 'PENDIENTE':
			return intl.formatMessage({ id: 'solicitudes.estado.pendiente', defaultMessage: 'PENDIENTE' });
		case 'LIBERADA':
			return intl.formatMessage({ id: 'solicitudes.estado.liberada', defaultMessage: 'LIBERADA' });
		case 'RECHAZADA':
			return intl.formatMessage({ id: 'solicitudes.estado.rechazada', defaultMessage: 'RECHAZADA' });
		case 'CANCELADA':
			return intl.formatMessage({ id: 'solicitudes.estado.cancelada', defaultMessage: 'CANCELADA' });
		default:
			return estado;
	}
};
